const route = {
	path: ':codeProject/levels',
	name: 'page-levels',
	meta: {
		title: 'Niveles',
	},
	props: true,
	component: () => import('@/pages/levels/page-levels'),
	children: [
		{
			path: 'new',
			name: 'page-new-levels',
			meta: {
				title: 'Agregar Nivel',
			},
			props: true,
			component: () => import('@/pages/levels/page-new-levels'),
		},
		{
			path: ':id/edit',
			name: 'page-edit-levels',
			meta: {
				title: 'Editar Nivel',
			},
			props: true,
			component: () => import('@/pages/levels/page-new-levels'),
		},
		{
			path: ':id/task',
			name: 'page-tasks-level',
			meta: {
				title: 'Tareas',
			},
			props: true,
			component: () => import('@/pages/task/page-task'),
			children: [
				{
					path: 'new',
					name: 'page-new-task',
					meta: {
						title: 'Agregar Tarea',
					},
					props: true,
					component: () => import('@/pages/task/page-new-task'),
				},
				{
					path: ':taskId/edit',
					name: 'page-edit-task',
					meta: {
						title: 'Editar Tarea',
					},
					props: true,
					component: () => import('@/pages/task/page-new-task'),
				},
			],
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/levels.js